import React, { PureComponent } from 'react';

// import i18n from '../../i18n';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import styles from './DistrictPage.module.scss';

import HeroFiftyFifty from '../../components/HeroFiftyFifty';
import ObjectList from '../../components/ObjectList/ObjectList';
import StreamField from '../../components/StreamField';
import { initQuickLinksDesignAndPosition } from '../../utils/experiments';
import Head from "next/head";


class DistrictPage extends PureComponent {
    state = {
        quickLinksVariant: 'original',
    };

    static defaultProps = {
        title: '',
    };

    static propTypes = {
        title: PropTypes.string.isRequired,
        contentBlocks: PropTypes.array,
    };

    componentDidMount() {
        initQuickLinksDesignAndPosition((quickLinksVariant) =>
            this.setState({ quickLinksVariant })
        );
    }

    render() {
        const { heroFiftyFifty, contentBlocks, objectList } = this.props

        return (
            <>
            <Head>
                <link rel="stylesheet" href="/third-party-styling/leaflet/leafletoriginal.css"/>
                <link rel="stylesheet" href="/third-party-styling/leaflet/leaflet.css"/>
                <link rel="stylesheet" href="/third-party-styling/leaflet/leaflet-marker-cluster.css"/>
            </Head>
            <div className={styles['DistrictPage']}>
                <div className={styles['DistrictPage__Section']}>
                    <HeroFiftyFifty {...heroFiftyFifty} />
                </div>
                {!!objectList?.items?.length && (
                    <div className={styles['DistrictPage__ObjectsContainer']}>
                        <div className={styles['DistrictPage__ObjectsContent']}>
                            <ObjectList
                                {...objectList}
                                isMyList={false}
                                showRemoveButtons={false}
                            />
                        </div>
                    </div>
                )}
                {contentBlocks && contentBlocks.length > 0 && (
                    <StreamField
                        items={contentBlocks}
                        fromStartpage={true}
                        experiments={{
                            quickLinksVariant: this.state.quickLinksVariant,
                        }}
                    />
                )}
            </div>
            </>
        );
    }
}

export default basePageWrap(DistrictPage);
